import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CreatePay, CreatePaymentSystemPay } from 'app/shared/models/class/systempay/systeme';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SystempayService {

  constructor(private http: HttpClient) { }

  /* -------------------------------------------------------------------------- */
  /*                                    POST                                    */
  /* -------------------------------------------------------------------------- */

  creatPayment(createPay: CreatePay) {
    return this.http.post(`${environment.apiUrl}/Systempay/CreatePayment`, createPay);
  }

  creatPaymentSystemePay(createPay: CreatePaymentSystemPay) {
    return this.http.post(`${environment.apiUrl}/Systempay/CreatePayment/validation`, createPay);
  }

  getTransaction() {
    return this.http.post(`${environment.apiUrl}/Systempay/GetTransaction`, '');
  }

  getOrder() {
    return this.http.post(`${environment.apiUrl}/Systempay/GetOrder`, '');
  }

  ipn() {
    return this.http.post(`${environment.apiUrl}/Systempay/IPN`, '');
  }

}
